<script setup>
import { Link, useForm } from '@inertiajs/vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import HotelSubMenu from '@/Includes/HotelSubMenu.vue';
import Swal from 'sweetalert2';
import { useToast } from 'vue-toast-notification';
import Loading from 'vue-loading-overlay';
import { ref, onMounted } from "vue";
import { Modal } from 'bootstrap';
import Multiselect from '@vueform/multiselect';

const props = defineProps({
    year: String,
    hotelsById: Object,
    flash: Object,
    allhotelfacilities: Array,
    user: Object,
});

const $toast = useToast();
let isLoading = ref(false);
let modalShow = ref(null);
let thisModalObj = null;
let menu = 'facilities';

const value = props.hotelsById.facilities.map((item) => {
    return {
        id: item.id,
        name: item.name
    }
});
const options = props.allhotelfacilities?.filter(r => !value.find(v => v.id === r.id));

onMounted(() => {
    thisModalObj = new Modal(modalShow.value);
});

const HotelFacilityAddform = useForm({
    hotelfacilities: [],
    hotel_id: props.hotelsById.id,
});

const HotelFacilityAddformSubmit = () => {
    HotelFacilityAddform.post('/facilities/store', {
        preserveScroll: true,
        onStart: () => isLoading.value = true,
        onFinish: () => isLoading.value = false,
        onSuccess: () => {
            thisModalObj.hide(),
                $toast.open({
                    message: props.flash.message,
                    type: "info",
                    duration: 4000,
                    position: 'top-right',
                    class: 'bs-toast toast bg-dark show'
                });
        }
    });
};

function deleteFacility(facilityid, hotelid) {
    new Swal({
        title: 'Are you sure?',
        text: "All the data related to this object will be deleted!",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        confirmButtonText: 'I am sure!'
    }).then((result) => {
        if (result.isConfirmed) {
            setTimeout(() => {
                window.location.href = '/facilities/delete/' + facilityid + '/' + hotelid;
            }, 300);

            $toast.success('Facility deleted successfully!', {
                position: 'top-right',
                duration: 4000,
                hideProgressBar: true,
                icon: true,
                type: "info",
                class: 'bs-toast toast bg-dark show'
            });
        }
    })
}

const FormReset = () => {
    HotelFacilityAddform.reset();
    HotelFacilityAddform.clearErrors();
};

</script>
<style scoped>
@import "../../../../public/ui/vendor/libs/toastr/toastr.css";
@import "vue-loading-overlay/dist/vue-loading.css";
@import "@vueform/multiselect/themes/default.css";
@import "sweetalert2/dist/sweetalert2.min.css";
@import "/css/hotelspace.css";
</style>

<template>
    <AppLayout title="Hotel Facilities" :year=year :user=user>
        <div class="vld-parent">
            <Loading v-model:active="isLoading" :color="'#696cff'" />
        </div>
        <div class="container-xxl flex-grow-1 container-p-y">
            <HotelSubMenu :hotelsById="hotelsById" :menu="menu" />
            <div class="row g-0">
                <div class="card">
                    <h5 class="card-header">Hotel Facilities</h5>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6 mt-5 mt-md-0">
                                <div class="added-cards">
                                    <div class="bg-lighter rounded-2 p-3 mb-3" v-for="facility in hotelsById.facilities"
                                        :key="facility.id" style="border: 1px solid #8592a3;">
                                        <div class="d-flex justify-content-between flex-sm-row flex-column">
                                            <div class="card-information me-2">
                                                <i style="font-size: 19px;" class="text-primary"
                                                    :class="facility.icon"></i>
                                                <div class="d-flex align-items-center mb-1 flex-wrap gap-2">
                                                    <h6 class="mb-0 me-2">{{ facility.name }}</h6>
                                                </div>
                                            </div>
                                            <div class="d-flex flex-column text-start text-sm-end"
                                                v-if="$page.props.user.permissions.includes('remove-facilities')">
                                                <div class="d-flex order-sm-0 order-1 mt-sm-0 mt-3">
                                                    <Link class="btn btn-label-secondary" href="#"
                                                        @click="deleteFacility(facility.id, hotelsById.id)"
                                                        preserve-scroll replace>
                                                    Delete
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 mt-5 mt-md-0">
                                <div class="text-center mt-4 mx-3 mx-md-0">
                                    <img src="/ui/img/illustrations/hotel-facilities.jpg" class="img-fluid" alt="meals"
                                        width="350">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="hotelFacilityModal" tabindex="-1" aria-modal="true" role="dialog" ref="modalShow">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Add Hotel Facilities</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <hr>
                    <form @submit.prevent="HotelFacilityAddformSubmit">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col mb-3">
                                    <label for="name" class="form-label"><b>Choose Facilities</b></label>
                                    <Multiselect v-model="HotelFacilityAddform.hotelfacilities" :options="options"
                                        mode="tags" :closeOnSelect="false" :searchable=true
                                        placeholder="Select hotel facilities ..." track-by="name" label="name"
                                        :object="true" :required=true />
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-label-secondary" data-bs-dismiss="modal"
                                @click="FormReset">
                                Close
                            </button>
                            <button type="submit" class="btn btn-primary">Add</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </AppLayout>
</template>